import React from 'react'
import { Form } from 'react-bootstrap';

const DatepickerComponent = ({ selectedValue, onChange }) => {
    return (
        <div className="date_div">
            <div className="row">
                <div className="date_picker">
                    <Form.Group controlId="doj">
                        <Form.Control 
                            type="date" 
                            name="doj" 
                            defaultValue={selectedValue} 
                            placeholder="" 
                            onChange={(e) => onChange(e)} 
                        />
                    </Form.Group>
                </div>
            </div>
        </div>
    )
}

export default DatepickerComponent;